import { render, staticRenderFns } from "./TierNavBackLink.vue?vue&type=template&id=277ddbe7&"
import script from "./TierNavBackLink.vue?vue&type=script&lang=js&"
export * from "./TierNavBackLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports